import { useDraggable } from "@dnd-kit/core";
import { Fragment } from "react";
import { Divider, Icon } from "@theorgchartdev/storybook";
import { CSS } from "@theorgchartdev/storybook";
import { GetWSMgr } from "@/Utils/StateLib";

export const CanvasMargin = props => {
  const marginData = props.margin;
  const { attributes, listeners, setNodeRef, transform, transition, setActivatorNodeRef } =
    useDraggable({
      id: marginData.id,
      disabled: marginData.disabled,
      data: marginData.value
    });

  if (!marginData.show) return;

  const draggableStyle = {
    transition,
    transform: CSS.Transform.toString(transform),
    cursor: "ns-resize"
  };

  const marginStyle = {
    position: "fixed",
    left: `${marginData.position.x}px`,
    top: `${marginData.position.y}px`,
    width: marginData.widthPx
  };

  const wsMgr = GetWSMgr();
  const docMgr = wsMgr?.GetDocMgr();
  const backgroundColor = docMgr?.GetBackgroundColor() ?? "transparent";
  const lightClass = wsMgr?.fCanvasPanel?.GetMarginLineColor() === "#EEEEEE";
  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...props.wrapperProps}
      style={{ ...draggableStyle, ...marginStyle }}
      tabIndex={-1}
    >
      <Fragment>
        <div
          className="handle"
          {...listeners}
          style={{
            cursor: "ns-resize",
            userSelect: "none",
            backgroundColor: `${backgroundColor}`
          }}
        >
          <div className={"handle-icon"}>
            <Icon name={"grip-lines"} size={"small"} modifier={lightClass ? "white" : "default"} />
          </div>
        </div>
        <div className={"divider-grip-line"} ref={setActivatorNodeRef} {...listeners}>
          <Divider {...props?.dividerProps} />
        </div>
      </Fragment>
    </div>
  );
};
